module.exports = __webpack_public_path__ + "img/fighting.76924c57.jpg";